// Code by Ruby - convx - 839
// Cart drawer gift with purchase feature
(() => {
  if (window.customElements.get('gift-option-picker')) {
    return;
  }

  class GiftOptionPicker extends HTMLElement {
    connectedCallback() {
      this.existingVariantId = this.dataset.existingGiftVariantId || '';
      this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
      this.button = this.querySelector('[data-action="add-gift"]');

      this.radios.forEach((radio) => radio.addEventListener('change', this._onSelectionChange.bind(this)));

      if (this.button) {
        this.button.addEventListener('click', this._onAddClick.bind(this));
      }
    }

    _selectedValue() {
      if (this.radios.length === 0) {
        const hiddenInput = this.querySelector('input[type="hidden"]');
        return hiddenInput ? hiddenInput.value : null;
      }

      const checked = this.radios.find((radio) => radio.checked);
      return checked ? checked.value : null;
    }

    _onSelectionChange() {
      if (!this.button) {
        return;
      }

      const selected = this._selectedValue();
      const isCurrentGift = !!this.existingVariantId && this.existingVariantId === selected;

      this.button.disabled = isCurrentGift;
      this.button.textContent = isCurrentGift ? this.button.dataset.labelAdded : this.button.dataset.labelAdd;
    }

    async _onAddClick() {
      const selectedVariantId = this._selectedValue();

      if (!selectedVariantId || this.button.disabled) {
        return;
      }

      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');

      try {
        if (this.existingVariantId && this.existingVariantId !== selectedVariantId) {
          await fetch(`${window.themeVariables.routes.cartChangeUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ id: this.existingVariantId, quantity: 0 })
          });
        }

        const addResponse = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: selectedVariantId, quantity: 1, properties: { _gift: 'true' } }],
            sections: ['mini-cart']
          })
        });

        const addResponseJson = await addResponse.json();

        if (!addResponse.ok) {
          throw new Error(addResponseJson.description || 'Unable to add gift');
        }

        const cartResponse = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
        const cartContent = await cartResponse.json();
        cartContent.sections = addResponseJson.sections;

        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartContent }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cartContent, openMiniCart: true }
        }));
      } catch (error) {
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
        console.error('[gift-option-picker]', error);
      }
    }
  }

  window.customElements.define('gift-option-picker', GiftOptionPicker);
})();
